<template>
    <div class="md-layout text-center login_biz">
      <div
        class=" md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <h1 slot="title" class="title login-title bg-transparent">Confirm Account</h1>
      </div>
      <div
        class="md-layout-item md-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page-fix"
      >>
        <login-card>
            <div class="logoWpr" slot="title"><img src="/img/logo-sm.png" alt="Bizminer small logo"></div>
            <h1 slot="title" class="title login-title">Account Confirmation</h1>
            <p v-if="confirming" slot="title" class="sub_title">Confirming email...</p>
            <p v-else-if="!confirming && confirmed" slot="title" class="sub_title">Thank you for confirming your email address. Click below to login in:</p>
            <p v-else slot="title" class="sub_title">Your email has not been confirmed. Please try again.</p>
            <div class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto" slot="content">
            <div v-if="confirmed">
              <md-button class="md-info md-round dark-blue-color" slot="footer" @click="$router.push({ name: 'Login' })">
                Login
              </md-button>
            </div>
            </div>
        </login-card>
      </div>
    </div>
  </template>
  
  <script>
    import { LoginCard } from "@/components";
  
    export default {
      components: {
        LoginCard,
      },
      data: () => ({
        confirming: true,
        confirmed: false,
      }),
      mounted() {
        if (this.$route.params.id && this.$route.params.token) {
            this.$store.dispatch("emailConfirm", {
              user_id: this.$route.params.id,
              token: this.$route.params.token,
            }).then(async (res) => {
              if (!res) {
                this.confirmed = false
              }
              if (!res.error) {
                this.confirmed = true
              } else {
                this.confirmed = false
              }
              this.confirming = false
            }).catch(() => {
              this.confirming = false
              this.$store.dispatch("alerts/error", "Your email has not been confirmed. Please try again.");
            });
          } else {
            this.confirming = false
            this.$store.dispatch("alerts/error", "Your email has not been confirmed. Please try again.");
          }
      }
    };
  </script>
    <style scoped>
    </style>
    